import React, { useState, useEffect } from 'react';
import imageToBase64 from '../../Hooks/imageToBase64';
import { useGetOutletByNameQuery, useServicesQuery } from '../../Store/Apis/outletApi';

const AddEditOutletForm = ({ outletData, onSubmit, outletName }) => {
    const getOutletByIDApi = useGetOutletByNameQuery(outletName, { skip: !outletName })
    const servicesList = useServicesQuery()

    const [formData, setFormData] = useState({
        outletId: '',
        outletName: '',
        outletCode: '',
        serviceCategoryID: '',
        serviceCategoryName: '',
        outletAddress: '',
        outletEmail: '',
        outletPhone: '',
        latitude: '',
        longitude: '',
        outletLogo: null,
        outletLogoPreview: ''
    });

    const [errors, setErrors] = useState({});

    
    useEffect(() => {        
        if(getOutletByIDApi.isSuccess){
            const {
                outletId,
                outletCode,
                outletName,
                workstationId,
                outletAddress,
                outletPhone,
                outletEmail,
                outletLatitude,
                outletLongitude,
                googleMap,
                googleReviews,
                qrCode,
                logo,
                checkinCheckout,
                serviceCategoryID,
                serviceCategoryName,
                isActive
            } = getOutletByIDApi?.data?.data;
            setFormData({
                outletId: outletId || '',
                outletName: outletName || '',
                outletCode: outletCode || '',
                serviceCategoryName: serviceCategoryName || '',
                serviceCategoryID: serviceCategoryID || '',
                outletAddress: outletAddress || '',
                outletEmail: outletEmail || '',
                outletPhone: outletPhone || '',
                latitude: outletLatitude || '',
                longitude: outletLongitude || '',
                outletLogo: logo,
                outletLogoPreview: logo,
                outletLogoString: logo,
                isActive: isActive
            });
            // console.log(base64ToFile('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAGHCAYAAAAjnnhCAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAgAElEQVR4nOzde5xdZXX4/89ae8/JZDIMQ4ghxhBj5IuYUkSKiJRSoIjcFQRUQBFv1CoiBZSrMVxERbxb/dZ6q5daongpUC+tUn8VKV6qfG1ERKABY4wQQgjJXPZe6/fHs/c5Z3KdhMlc1/v1CiRzztlnzz5n7'))
        }
    }, [getOutletByIDApi.isSuccess]);

    const validateForm = () => {
        let tempErrors = {};
        if (!formData.outletName) tempErrors.outletName = 'Outlet Name is required';
        if (!formData.serviceCategoryID) tempErrors.serviceCategoryID = 'Service Category is required';
        if (!formData.outletEmail) tempErrors.outletEmail = 'Email is required';
        if (!formData.outletPhone) tempErrors.outletPhone = 'Phone number is required';
        return tempErrors;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            imageToBase64(file).then(base64String => {
                setFormData({
                    ...formData,
                    outletLogo: file,
                    outletLogoPreview: URL.createObjectURL(file),
                    outletLogoString: base64String
                });
            }).catch(error => {
                console.error('Error converting image to Base64:', error);
            });
        }
    };
    
    // Function to handle image removal
    const handleRemoveImage = () => {
        setFormData({
            ...formData,
            outletLogo: null,
            outletLogoPreview: '',
            outletLogoString: ''
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            onSubmit(formData);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row gy-2">
                <div className="col-md-6">
                    <div>
                        <label htmlFor="outletName" className="form-label">Outlet Name *</label>
                        <input
                            type="text"
                            className={`form-control ${errors.outletName ? 'is-invalid' : ''}`}
                            id="outletName"
                            name="outletName"
                            value={formData.outletName}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess}
                        />
                        {errors.outletName && <div className="invalid-feedback">{errors.outletName}</div>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="">
                        <label htmlFor="outletCode" className="form-label">Outlet Code</label>
                        <input
                            type="text"
                            className="form-control"
                            id="outletCode"
                            name="outletCode"
                            value={formData.outletCode}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="">
                        <label htmlFor="serviceCategoryName" className="form-label">Assign Service Category *</label>
                        <select
                            className={`form-select ${errors.serviceCategory ? 'is-invalid' : ''}`}
                            id="serviceCategoryName"
                            name="serviceCategoryID"
                            value={formData.serviceCategoryID}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess && !servicesList.isSuccess}
                        >
                            <option value="">Select Service Category</option>
                            {
                                servicesList?.data?.data.map((elem, i)=> {
                                    return (<option value={elem.id} key={i}>{elem.name}</option>)
                                })
                            }
                        </select>
                        {errors.serviceCategoryID && <div className="invalid-feedback">{errors.serviceCategoryID}</div>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="">
                        <label htmlFor="outletEmail" className="form-label">Outlet Email *</label>
                        <input
                            type="email"
                            className={`form-control ${errors.outletEmail ? 'is-invalid' : ''}`}
                            id="outletEmail"
                            name="outletEmail"
                            value={formData.outletEmail}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess}
                        />
                        {errors.outletEmail && <div className="invalid-feedback">{errors.outletEmail}</div>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="">
                        <label htmlFor="outletPhone" className="form-label">Outlet Phone *</label>
                        <input
                            type="tel"
                            className={`form-control ${errors.outletPhone ? 'is-invalid' : ''}`}
                            id="outletPhone"
                            name="outletPhone"
                            value={formData.outletPhone}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess}
                        />
                        {errors.outletPhone && <div className="invalid-feedback">{errors.outletPhone}</div>}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="">
                        <label htmlFor="outletAddress" className="form-label">Outlet Address</label>
                        <textarea
                            className="form-control"
                            id="outletAddress"
                            name="outletAddress"
                            value={formData.outletAddress}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess}
                        ></textarea>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="">
                        <label htmlFor="latitude" className="form-label">Latitude</label>
                        <input
                            type="number"
                            className="form-control"
                            id="latitude"
                            name="latitude"
                            value={formData.latitude}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="">
                        <label htmlFor="longitude" className="form-label">Longitude</label>
                        <input
                            type="number"
                            className="form-control"
                            id="longitude"
                            name="longitude"
                            value={formData.longitude}
                            onChange={handleInputChange}
                            disabled={outletName && !getOutletByIDApi.isSuccess}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <label htmlFor="outletLogo" className="form-label">Outlet Logo</label>
                    <input
                        type="file"
                        className="form-control"
                        id="outletLogo"
                        name="outletLogo"
                        accept="image/*"  // Restrict to image files only
                        onChange={handleFileChange}
                        disabled={outletName && !getOutletByIDApi.isSuccess}
                    />

                    {formData.outletLogoPreview && (
                        <div className="mt-3 position-relative text-center" style={{ maxWidth: '150px' }}>
                            <img
                                src={formData.outletLogoString}
                                alt="Logo Preview"
                                className="img-thumbnail d-block"
                            />
                            <button
                                type="button"
                                className="btn badge badge-xs badge-danger position-absolute"
                                onClick={handleRemoveImage}
                                style={{ top: '6px', right: '6px', zIndex: '1' }}
                            >
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                    )}
                </div>
            </div>

            


            <button type="submit" className="btn btn-primary mt-3">
                {outletData ? 'Update Outlet' : 'Add Outlet'}
            </button>
        </form>
    );
};


export default AddEditOutletForm;
